import type { AxiosRequestConfig } from "axios";
import qs from "qs";
import { axiosInstance } from "../../axios-instance";
import { qsOptions } from "../qsOptions";
import type { R } from "../types";
import type {
  IGetAddressDetailsRequest,
  IGetAddressDetailsResponse,
  IGetAddressesRequest,
  IGetAddressesResponse,
} from "./types";

export class AddressService {
  async getAddresses(
    p: IGetAddressesRequest,
    c?: AxiosRequestConfig,
  ): R<IGetAddressesResponse> {
    const params = qs.stringify({ input: p.query }, qsOptions);
    return axiosInstance.get(`/api/address/autocomplete?${params}`, c);
  }

  async getAddressDetails(
    p: IGetAddressDetailsRequest,
    c?: AxiosRequestConfig,
  ): R<IGetAddressDetailsResponse> {
    const params = qs.stringify(p, qsOptions);
    return axiosInstance.get(`/api/address/placeDetails?${params}`, c);
  }
}
